export { SUVCarIcon } from './car-shape-suv'
